import { Button } from '@cian/ui-kit';
import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import { NoteButtonContainer } from '../../containers/NoteButton';
import { Phone } from '../Phone';
import { RemoveFavoriteContainer } from '../../containers/RemoveFavorite';
import { trackGoJKClick } from './trackings';
import { IPageState } from '../../types/page';
import { TUser } from '../../api';

import * as styles from './FavoriteEntityControlsBar.css';
import { ComplainContainer } from '../../containers/Complain';
import { IFavoriteEntity } from '../../types/results';
import { EEntityType } from '../../types/filters';
import { AddedFavoriteEntityMenu } from '../AddedFavoriteEntityMenu';
import { AddToFolderButtonContainer } from '../../containers/AddToFolderButtonContainer';

export interface IFavoriteEntityControlsBarStoreProps {
  page: IPageState;
  favoriteEntities: IFavoriteEntity[];
  total: number;
  user: TUser;
  printPhoneNumbers: boolean;
}

export interface IFavoriteEntityControlsBarOwnProps {
  favoriteEntity: IFavoriteEntity;
}

export type TFavoriteEntityControlsBarProps = IFavoriteEntityControlsBarStoreProps & IFavoriteEntityControlsBarOwnProps;

/**
 * Все добавленные кнопки <button /> нужно оборачивать
 * в div, которые будут контейнерами-толкателями кнопок
 */
export class FavoriteEntityControlsBar extends React.PureComponent<TFavoriteEntityControlsBarProps> {
  public render() {
    const {
      favoriteEntity: { entityId, entityType, note, phone, categoryComplaintId, dealType, jkInfo, fullUrl, geo },
      favoriteEntities,
      total,
      page,
      user,
      printPhoneNumbers,
    } = this.props;

    const regionId = geo.regionId;
    const isNoteButtonShow = (!note || !note.length) && entityType !== 'newbuilding';
    const favoriteEntityType = (entityType as unknown) as EEntityType;
    const phoneButton = (
      <Phone
        phone={phone}
        entityId={entityId}
        favoriteEntities={favoriteEntities}
        page={page}
        user={user}
        total={total}
      />
    );

    return (
      <>
        <div className={styles.controls}>
          {jkInfo && (
            <div>
              <Button
                size="XS"
                theme="fill_secondary"
                onClick={() => {
                  window.open(fullUrl, '_blank');
                  trackGoJKClick(page, user, entityId, favoriteEntities, total);
                }}
              >
                Перейти к ЖК
              </Button>
            </div>
          )}
          {phoneButton}
          {!jkInfo && <AddToFolderButtonContainer entityId={entityId} />}
          {isNoteButtonShow && <NoteButtonContainer entityId={entityId} />}
          <RemoveFavoriteContainer dealType={dealType} entityId={entityId} favoriteEntityType={favoriteEntityType} />
          {// Не отображаем кнопку "Пожаловаться" для ЖК
          !jkInfo && (
            <ComplainContainer
              regionId={regionId}
              userEmail={(user.isAuthenticated && user.email) || ''}
              fullUrl={fullUrl}
              offerId={entityId}
              offerCategoriesIds={categoryComplaintId ? [categoryComplaintId] : []}
            />
          )}
          {!jkInfo && (
            <AddedFavoriteEntityMenu entityId={entityId} dealType={dealType} favoriteEntityType={favoriteEntityType} />
          )}
        </div>
        {printPhoneNumbers && <div {...mergeStyles(styles.controls, styles['print-mode'])}>{phoneButton}</div>}
      </>
    );
  }
}
